<template>
  <v-container fluid>
    <v-row align="stretch" class="mx-0">
      <v-col cols="12" md="8" class="flex-grow-1">
        <v-card outlined height="100%">
          <v-card-text>
            <v-alert
              v-if="
                (currentPermission.privilegeLevel == 'admin' ||
                  currentPermission.privilegeLevel == 'editor') &&
                businessProfile.isBusinessCardDesignAdded == false
              "
              color="primary"
              text
            >
              <div class="text--primary text-h6">Brand your business card</div>
              <div class="text--primary text-body-2 pb-4">
                A branded business card leaves a professional first impression
                when connecting with people.
              </div>
              <v-btn
                depressed
                color="primary"
                width="240"
                @click="$router.push('cardDesign')"
                >Add branding</v-btn
              >
            </v-alert>

            <div class="d-flex justify-space-between">
              <div>
                <span class="text-h6 text--primary">Your Card Design</span>
                <div>
                  Details shown on your card design is for illustrative purposes
                  only.
                </div>
              </div>

              <v-tooltip
                v-if="
                  currentPermission.privilegeLevel == 'admin' ||
                  currentPermission.privilegeLevel == 'editor'
                "
                bottom
              >
                <template #activator="{ on: onTooltip }">
                  <v-btn
                    text
                    class="mx-2"
                    fab
                    dark
                    color="primary"
                    v-on="{ ...onTooltip }"
                    @click="$router.push('cardDesign')"
                  >
                    <v-icon dark>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </div>

            <!-- <AddEditBusinessCardDialog
              v-model="addEditBusinessCardDialog"
              v-if="
                currentPermission.privilegeLevel == 'admin' ||
                currentPermission.privilegeLevel == 'editor'
              "
            /> -->

            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6">
                <BusinessCardFront
                  :logoFrame="businessProfile.logoFrame"
                  :cardCorners="businessProfile.cardCorners"
                  :logoImageURL="businessProfile.logoImageURL"
                  v-tilt
                />
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <BusinessCardBack
                  :cardCorners="businessProfile.cardCorners"
                  :reverseImageURL="businessProfile.reverseImageURL"
                  v-tilt
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" class="flex-grow-1">
        <v-card outlined height="100%">
          <v-card-text>
            <div class="d-flex justify-space-between align-center">
              <span class="text-h6 text--primary"
                >Your Business Badge & QR Code Design</span
              >
              <v-tooltip
                v-if="
                  currentPermission.privilegeLevel == 'admin' ||
                  currentPermission.privilegeLevel == 'editor'
                "
                bottom
              >
                <template #activator="{ on: onTooltip }">
                  <v-btn
                    text
                    class="mx-2"
                    fab
                    dark
                    color="primary"
                    v-on="{ ...onTooltip }"
                    @click="$router.push({ name: 'manageBadgeQRCode' })"
                  >
                    <v-icon dark>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </div>

            <div
              class="
                d-flex
                justify-space-between
                align-center
                flex-sm-column flex-lg-row
                py-8
              "
            >
              <Badge :size="140" :logo="badgeImageUrl" />

              <div>
                <QRCode
                  :showDownloadButton="false"
                  link="https://pappyon.com/"
                  :logo="businessProfile.qrCodeImageURL"
                  :size="150"
                />
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <v-alert
              v-if="
                (currentPermission.privilegeLevel == 'admin' ||
                  currentPermission.privilegeLevel == 'editor') &&
                businessProfile.isBusinessCardInformationAdded == false
              "
              color="primary"
              text
            >
              <div class="text--primary text-h6">
                Drive traffic to your websites and socials
              </div>
              <div class="text--primary text-body-2 pb-4">
                Establish the details that you would like to attach to the
                business card you issue to each team member. This may include
                information such as an address, general email address, contact
                numbers, and the urls for your website and social media
                channels.
              </div>
              <v-btn
                to="/manageBusinessProfile"
                depressed
                color="primary"
                width="240"
                >Add business information</v-btn
              >
            </v-alert>
            <div class="d-flex justify-space-between">
              <span class="text-h6 text--primary">Your Business Profile</span>
              <v-tooltip bottom>
                <template #activator="{ on: onTooltip }">
                  <v-btn
                    v-if="
                      currentPermission.privilegeLevel == 'admin' ||
                      currentPermission.privilegeLevel == 'editor'
                    "
                    text
                    class="mx-2"
                    v-on="{ ...onTooltip }"
                    fab
                    dark
                    color="primary"
                    to="/manageBusinessProfile"
                  >
                    <v-icon dark>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </div>
            <p class="text--secondary">
              The contact details and links you enter on this form are
              considered as the general details for your business and they will
              attach to each card you issue.
            </p>
            <v-row class="my-0 py-0">
              <v-col
                v-if="
                  businessProfile.businessName != null &&
                  businessProfile.businessName != ''
                "
                cols="12"
                md="4"
                class="ma-0 pa-0"
              >
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item class="my-0 py-0">
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>work</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle>Business Name</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">{{
                        businessProfile.businessName
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col
                v-if="
                  businessProfile.websiteURL != null &&
                  businessProfile.websiteURL != ''
                "
                cols="12"
                md="4"
                class="ma-0 pa-0"
              >
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item>
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>web</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle>Website</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">{{
                        urlPrefixes.urlPrefix + businessProfile.websiteURL
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col
                v-if="
                  businessProfile.facebookURL != null &&
                  businessProfile.facebookURL != ''
                "
                cols="12"
                md="4"
                class="ma-0 pa-0"
              >
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item>
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>mdi-facebook</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle
                        >Business Facebook URL</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-medium">{{
                        urlPrefixes.facebookUrlPrefix +
                        businessProfile.facebookURL
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col
                v-if="
                  businessProfile.instagramURL != null &&
                  businessProfile.instagramURL != ''
                "
                cols="12"
                md="4"
                class="ma-0 pa-0"
              >
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item>
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>mdi-instagram</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle
                        >Business Instagram URL</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-medium">{{
                        urlPrefixes.instagramUrlPrefix +
                        businessProfile.instagramURL
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col
                v-if="
                  businessProfile.twitterURL != null &&
                  businessProfile.twitterURL != ''
                "
                cols="12"
                md="4"
                class="ma-0 pa-0"
              >
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item>
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>mdi-twitter</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle
                        >Business Twitter URL</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-medium">{{
                        urlPrefixes.twitterUrlPrefix +
                        businessProfile.twitterURL
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col
                v-if="
                  businessProfile.linkedinURL != null &&
                  businessProfile.linkedinURL != ''
                "
                cols="12"
                md="4"
                class="ma-0 pa-0"
              >
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item>
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>mdi-linkedin</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle
                        >Business Linkedin URL</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-medium">{{
                        urlPrefixes.linkedinUrlPrefix +
                        businessProfile.linkedinURL
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>

              <v-col
                v-if="
                  businessProfile.youtubeURL != null &&
                  businessProfile.youtubeURL != ''
                "
                cols="12"
                md="4"
                class="ma-0 pa-0"
              >
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item>
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>mdi-youtube</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle>Youtube</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">{{
                        urlPrefixes.youtubeurlPrefix +
                        businessProfile.youtubeURL
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>

              <v-col
                v-if="
                  businessProfile.podcastURL != null &&
                  businessProfile.podcastURL != ''
                "
                cols="12"
                md="4"
                class="ma-0 pa-0"
              >
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item>
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>mdi-podcast</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle>Podcast</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">{{
                        urlPrefixes.urlPrefix + businessProfile.podcastURL
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>

              <template
                v-for="(item, index) in businessProfile.otherDetails || []"
              >
                <v-col
                  :key="`other-detail-list-item${index}`"
                  v-if="item.value != null && item.value.trim() != ''"
                  cols="12"
                  md="4"
                  class="ma-0 pa-0"
                >
                  <v-list two-line subheader class="ma-0 pa-0">
                    <v-list-item>
                      <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                        <v-icon dark>{{
                          getOtherDetailPrependIcon(item.fieldId)
                        }}</v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-subtitle>{{
                          getOtherDetailDisplayText(item.fieldId)
                        }}</v-list-item-subtitle>
                        <v-list-item-title
                          class="font-weight-medium"
                          v-if="item.fieldId == 'PHONE'"
                          >{{
                            item.countryPhoneCodeNumber +
                            " " +
                            getOtherDetailPrefix(item.fieldId) +
                            item.value
                          }}</v-list-item-title
                        >
                        <v-list-item-title class="font-weight-medium" v-else>{{
                          getOtherDetailPrefix(item.fieldId) + item.value
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// @ is an alias to /src
import BusinessCardFront from "@/components/BusinessCardFront";
import BusinessCardBack from "@/components/BusinessCardBack";
import AddEditBusinessCardDialog from "@/components/AddEditBusinessCardDialog";
import AddEditBusinessDetailsDialog from "@/components/AddEditBusinessDetailsDialog";
import { mapGetters } from "vuex";
import BusinessProfileUtility from "@/shared/business-profile-utility";
import QRCode from "@/components/QRCode";
import Badge from "@/components/BadgeAndQRCode/Badge";

export default {
  name: "ManageCard",
  created() {
    this.getOtherDetailDisplayText =
      BusinessProfileUtility.getOtherDetailDisplayText;
    this.getOtherDetailPrefix = BusinessProfileUtility.getOtherDetailPrefix;
    this.getOtherDetailPrependIcon =
      BusinessProfileUtility.getOtherDetailPrependIcon;
  },
  components: {
    BusinessCardFront,
    BusinessCardBack,
    AddEditBusinessCardDialog,
    AddEditBusinessDetailsDialog,
    QRCode,
    Badge,
  },
  data() {
    return {
      addEditBusinessCardDialog: false,
    };
  },
  computed: {
    ...mapGetters([
      "businessProfile",
      "mainBusinessAddress",
      "urlPrefixes",
      "currentPermission",
    ]),

    badgeImageUrl() {
      let badgeImageUrl = this.businessProfile.badgeImageURL
        ? this.businessProfile.badgeImageURL
        : "";
      return badgeImageUrl;
    },
  },
};
</script>
<style scoped>
/* .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #10163f !important;
}
.theme--light.v-list-item .v-list-item__subtitle, .theme--light.v-list-item .v-list-item__action-text {
  color: #10163f;
} */

.badge-container {
  position: relative;
}
.badge-container .user-image {
  display: block;
}
.badge-container .badge-image {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
